if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      this.button = this.querySelector('[type="submit"]');

      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          /* this.addEventListener('submit', this.handleSubmit.bind(this)); */
          this.button.addEventListener("click", this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      console.debug('[ProductForm] handleSubmit called', { evt });

      if (evt.target.id === 'product-signup_form') {
        console.debug('[ProductForm] Submission is for signup form, aborting.');
        return;
      }

      evt.preventDefault();
      console.debug('[ProductForm] Default form submission prevented.');

      // Handle personalise shirt addons
      const personaliseShirtOptions = document.querySelectorAll('[data-personalise-option]');
      console.debug('[ProductForm] Found personaliseShirtOptions:', personaliseShirtOptions);

      if (personaliseShirtOptions && personaliseShirtOptions.length > 0) {
        const hasBeenPersonalised = Array.from(personaliseShirtOptions).some(option => option.checked);
        const personaliseOptOut = document.getElementById('personaliseOptOut');
        const hasOptedOut = personaliseOptOut?.checked || false;
        console.debug('[ProductForm] Personalised:', hasBeenPersonalised, 'Opted out:', hasOptedOut);

        if (!hasBeenPersonalised && !hasOptedOut) {
          console.debug('[ProductForm] Missing personalization options and not opted out.');
          this.setErrorMsgState('Missing personalization options. Opt out of personalizing using the button above.');
          return;
        }
      }

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') {
        console.debug('[ProductForm] Submit button is disabled, aborting.');
        return;
      }

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        console.debug('[ProductForm] Vibrating device for ATC.');
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();
      console.debug('[ProductForm] Cleared error message state.');

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');
      console.debug('[ProductForm] Disabled submit button and set loading state.');

      // If customer is not personalising a product, retrieve the non 'PERS' variant ID
      try {
        const optOutCheckbox = document.getElementById('personaliseOptOut');
        if (optOutCheckbox) {
          let activeSku = document.querySelector('.product-sku__value').innerText;
          console.debug('[ProductForm] Active SKU before personalisation logic:', activeSku);

          if (optOutCheckbox.checked && activeSku.includes('-PERS')) {
            activeSku = activeSku.replace('-PERS', '');
            console.debug('[ProductForm] Opted out, removed -PERS:', activeSku);
          } else if (!optOutCheckbox.checked && !activeSku.includes('-PERS')) {
            activeSku = activeSku += '-PERS';
            console.debug('[ProductForm] Not opted out, added -PERS:', activeSku);
          }
          const newSkuInput = this.form.querySelector(`input[type="hidden"][data-sku*="${activeSku}"]`);
          if (newSkuInput) {
            const newSku = newSkuInput.dataset.id;
            this.form.querySelector('[name="id"]').value = newSku;
            console.debug('[ProductForm] Updated form variant id to:', newSku);
          } else {
            console.warn('[ProductForm] Could not find hidden input for SKU:', activeSku);
          }
        }
      } catch (error) {
        this.setErrorMsgState('There was an error adding this product to your basket');
        console.error('[ProductForm] Add to Cart Error', error);
      }

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        const sectionId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections += `,${sectionId}`;
        console.debug('[ProductForm] Added cart drawer section:', sectionId);
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);
      console.debug('[ProductForm] Appended sections and sections_url to formData:', sections, window.location.pathname);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };
      console.debug('[ProductForm] Fetch request options:', fetchRequestOpts);

      try {
        console.debug('[ProductForm] Fetching old cart data...');
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();
        console.debug('[ProductForm] Old cart data:', oldCartData);

        console.debug('[ProductForm] Sending add to cart request...');
        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        console.debug('[ProductForm] Add to cart response data:', data);

        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
          console.debug('[ProductForm] Cart add errors:', error);
        }

        if (data.status) {
          console.debug('[ProductForm] Error status in response, setting error message.');
          this.setErrorMsgState(error);
        }

        if (!response.ok) {
          console.error('[ProductForm] Add to cart response not ok:', response.status);
          throw new Error(response.status);
        }

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          console.debug('[ProductForm] Redirecting to cart page after ATC.');
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          console.debug('[ProductForm] Updating cart icon.');
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) {
            console.debug('[ProductForm] Added from quick add drawer, showing added message.');
            quickAddDrawer.addedToCart();
          }

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              console.debug('[ProductForm] Updating cart drawer contents.');
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  console.debug('[ProductForm] Cart is empty, reloading page.');
                  window.location.reload();
                } else {
                  console.debug('[ProductForm] Refreshing cart items.');
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        console.debug('[ProductForm] Fetching new cart data...');
        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        console.debug('[ProductForm] New cart data:', newCartData);

        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];
        console.debug('[ProductForm] Item in old cart:', itemInOldCart);

        // Check if product was already in the cart
        if (itemInOldCart) {
          console.debug('[ProductForm] Product already in cart, dispatching on:line-item:change event.');
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          console.debug('[ProductForm] Product not in cart, dispatching on:cart:add event.');
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));

          console.debug('[ProductForm] Pushing add_to_cart event to dataLayer.');
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: window._currencysignCustom,
              value: Number(data.price / 100),
              items: [{
                item_name: data.product_title,
                item_id: data.sku,
                price:  Number(data.price / 100),
                item_brand: data.vendor,
                item_category: data.product_type,
                item_variant: data.variant_title,
                in_stock: "yes",
                on_offer: data.total_discount != 0 ? "yes":"no",
                index: 0,
                quantity: data.quantity
              }]
            }
          });
        }
      } catch (error) {
        console.error('[ProductForm] Error during add to cart process:', error);
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        console.debug('[ProductForm] Re-enabling submit button and removing loading state.');
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
